export default {
    'invoice-no': 'Invoice No.',
    new: 'New',
    delete: 'Delete',
    account: 'Account',
    'invoice-date': 'Invoice date',
    warehouse: 'Warehouse',
    document: 'Ref. Doc.',
    'net-invoice': 'Grand Amount',
    edit: 'Edit',
    save: 'Save',
    not: 'Non',
    posted: 'Posted',
    'add-invoice': 'Add invoice',
    notes: 'Notes',
    create: 'Create',
    cancel: 'Cancel',

    'delete-entry': 'Delete Item',
    'are-you-sure-you-want-to-delete-the-entry': 'Do you want to delete this item?',
    
    'delete-invoice': 'Delete invoice',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'Do you want to  delete this invoice? the related bond will also be deleted?',
    discount: 'Discount',
    total: 'Total',

    headers: {
        no: 'Serial',
        warehouse: 'Warehouse',
        material: 'Item',
        quantity: 'Quantity',
        count: 'Count',
        price: 'Price',
        'total-amount': 'Net amount',
        'notes': 'Notes',
        'delivery-status': 'Delivery status'
    },

    'context-menu': {
        edit: 'Edit',
        delete: 'Delete'
    },
    payments: 'Payments',
    'total-payments': 'Total payments',
    'alert-message': 'Alert message',
    'confirm-message': 'The total receipts have become greater than the total. Do you want to continue?',
    'total-expenses': 'Total expenses',
    'expenses': 'Expenses'
}